export const logError = (message, passedContext) => {
    // eslint-disable-next-line no-console
    console.error(message, passedContext);
};
